// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Dof-","col":"styles_col__2xQjQ"};